<template>
    <label class="switch">
        <input v-model="checked" type="checkbox">
        <span></span>
    </label>
</template>

<script>
    export default {
        name: "brainSwitch",
        data () {
            return {
                checked: this.value
            }
        },
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value (val) {
                this.checked = val;
            },
            checked (val) {
                this.$emit('input', val);
                this.$emit('change', val)
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    .switch{
        width:40px;
        height:20px;
        border-radius:30px;
        overflow: hidden;
        vertical-align:middle;
        position:relative;
        display: inline-block;
        background:#ECECEC;
        cursor: pointer;
    }
    .switch input{
        top: 0;
        margin-top: 0;
        visibility: hidden;
    }
    .switch span{
        position:absolute;
        top:0;
        left:1px;
        border-radius: 50%;
        background:#fff;
        width:50%;
        height:100%;
        transition:all linear 0.2s;
    }
    .switch span::before{
        position: absolute;
        top: 0 !important;
        left: -50px !important;
        content: '';
        width: 38px !important;
        height: 100% !important;
        border-radius: 30px !important;
        background: #2196f3 !important;
    }
    .switch span::after{
        content:'';
        position:absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        border-radius: 50%;
        background:#fff;
    }
    .switch input:checked +span{
        transform:translateX(calc(100% - 2px));
    }
    .switch input:checked +span::before{
        left: -20px !important;
    }
</style>
